import {
    LICENCE_CATEGORY,
    LICENCE_VALIDITY_PERIOD,
    OTHER_DETAILS,
    FOREIGN_COMPANY_DETAILS,
    OPERATING_LOCATION,
    EXHIBITION_INFORMATION,
    EXHIBITION_ADDRESS,
    EXHIBITION_PERIOD,
    TYPE_OF_EXHIBITION,
    TYPE_OF_EQUIPMENT,
    STATION,
    BASE_STATION_INFORMATION,
    RADIO_EQUIPMENT_INFORMATION,
    SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/EXBApplication';

import {
    LICENCE_DETAILS,
    SUPPORTING_DOCUMENTS as CANCEL_SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/cancelLicence';

import { SUPPORTING_DOCUMENTS as AMEND_SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyApplication/amendLicence';
import { LICENCE_DETAILS as RENEW_LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/renewLicence';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';

import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

export const formatEXBApplication = async (
    licenceDetails: any,
    caseTypeID: string,
    application?: string,
    totalNoOfStations?: string,
    transactionType?: any
) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    let baseLandFixedStationInfoList = [];
    let stationList = [];
    let operatingLocation = [];

    newDocs = [];

    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    for (const key in licenceDetails.supportingDocuments) {
        if (licenceDetails.supportingDocuments.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.supportingDocuments[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    if (licenceDetails && licenceDetails.baseLandFixedStationInfo && licenceDetails.baseLandFixedStationInfo.length > 0) {
        baseLandFixedStationInfoList = licenceDetails?.baseLandFixedStationInfo?.map((value: Record<string, any>, index: number) => ({
            [`${BASE_STATION_INFORMATION}-station-or-equipment-name`]: value?.stationName ?? '-',
            [`${BASE_STATION_INFORMATION}-purpose-and-objectives`]: value?.purposeAndObjectives ?? '-',

            [`${RADIO_EQUIPMENT_INFORMATION}-brand-and-model-transmitter`]: value?.transmitterModel ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-brand-and-model-receiver`]: value?.receiverModel ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-serial-no-transmitter`]: value?.serialNoTransmitter ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-serial-no-receiver`]: value?.serialNoReceiver ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-rf-output-power-transmitter`]: value?.outputPowerWTransmitter ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-rf-output-power-receiver`]: value?.outputPowerWReceiver ?? '-',
        }));
    }

    if (licenceDetails && licenceDetails.baseLandFixedStationInfo && licenceDetails.baseLandFixedStationInfo.length > 0) {
        stationList = licenceDetails?.baseLandFixedStationInfo?.map((value: Record<string, any>, index: number) => {
            const list = {
                id: index + 1,
                label: value?.stationName
            };

            return list;
        });
    }

    if (licenceDetails && licenceDetails.operatingAddressInformation && licenceDetails.operatingAddressInformation.length > 0) {
        operatingLocation = licenceDetails?.operatingAddressInformation.map((value: any, i: number) => ({
            'no': `${i + 1 }`,
            'building-name': value?.address?.buildingName ?? '-',
            'street-name': value?.address?.streetName ?? '-',
            'block-house-no': value?.address?.blockNo ?? '-',
            'floor-level': value?.address?.floor ?? '-',
            'unit': value?.address?.unit ?? '-',
            'postal-code': value?.address?.postalCode ?? '-'
        }));
    }

    licence = {
        id: 'exhibition-of-telecommunication-equipment-without-frequency',
        formID: 'exhibition-of-telecommunication-equipment-without-frequency',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {

            [`${LICENCE_CATEGORY}-licence-category`]: licenceDetails?.LicenceCategoryDetails?.pleaseSelectTheLicenceYouWishToApply ?? '-',

            [`${OTHER_DETAILS}-proposed-used-of-system`]: licenceDetails?.otherDetails?.proposedUseOfSystemEquipment ?? '-',
            [`${OTHER_DETAILS}-remarks`]: licenceDetails?.otherDetails?.remarks ?? '-',

            [`${FOREIGN_COMPANY_DETAILS}-foreign-company-name`]: licenceDetails?.organisationInformation?.companyName ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-address-line-one`]: licenceDetails?.organisationInformation?.registeredAddress?.foreignAddressLine1 ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-address-line-two`]: licenceDetails?.organisationInformation?.registeredAddress?.foreignAddressLine2 ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-address-line-three`]: licenceDetails?.organisationInformation?.registeredAddress?.foreignAddressLine3 ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-address-line-four`]: licenceDetails?.organisationInformation?.registeredAddress?.foreignAddressLine4 ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-address-line-five`]: licenceDetails?.organisationInformation?.registeredAddress?.foreignAddressLine5 ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-contact-number`]: licenceDetails?.organisationInformation?.telNumber ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-email`]: licenceDetails?.organisationInformation?.email ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-city`]: licenceDetails?.organisationInformation?.registeredAddress?.city ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-state`]: licenceDetails?.organisationInformation?.registeredAddress?.state ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-zip-code`]: licenceDetails?.organisationInformation?.registeredAddress?.zipCode ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-country`]: licenceDetails?.organisationInformation?.registeredAddress?.country ?? '-',

            [`${OPERATING_LOCATION}-list`]: operatingLocation ?? [...operatingLocation],

            [`${EXHIBITION_INFORMATION}-organizer-name`]: licenceDetails?.ExhibitionDetails?.CompanyName ?? '-',
            [`${EXHIBITION_INFORMATION}-organizer-contact-person`]: licenceDetails?.ExhibitionDetails?.contactPersonParticulars?.name ?? '-',
            [`${EXHIBITION_INFORMATION}-designation`]: licenceDetails?.ExhibitionDetails?.contactPersonParticulars?.designation ?? '-',
            [`${EXHIBITION_INFORMATION}-tel-no`]: licenceDetails?.ExhibitionDetails?.contactPersonParticulars?.officeTelNumber ?? '-',
            [`${EXHIBITION_INFORMATION}-mobile-no`]: licenceDetails?.ExhibitionDetails?.contactPersonParticulars?.mobileNumber ?? '-',
            [`${EXHIBITION_INFORMATION}-fax-no`]: licenceDetails?.ExhibitionDetails?.contactPersonParticulars?.faxNumber ?? '-',
            [`${EXHIBITION_INFORMATION}-email`]: licenceDetails?.ExhibitionDetails?.contactPersonParticulars?.email ?? '-',
            [`${EXHIBITION_INFORMATION}-exhibition-name`]: licenceDetails?.ExhibitionDetails?.contactPersonParticulars?.name ?? '-',
            [`${EXHIBITION_INFORMATION}-exhibition-booth-no`]: licenceDetails?.ExhibitionDetails?.BoothNo ?? '-',

            [`${EXHIBITION_PERIOD}-start-date`]: formatDateTo_ddMMyyyy(licenceDetails?.ExhibitionDetails?.StartDate) ?? '-',
            [`${EXHIBITION_PERIOD}-end-date`]: formatDateTo_ddMMyyyy(licenceDetails?.ExhibitionDetails?.EndDate) ?? '-',

            [`${EXHIBITION_ADDRESS}-address-type`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.addressType ?? '-',
            [`${EXHIBITION_ADDRESS}-address-line-one`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.addressLine1 ?? '-',
            [`${EXHIBITION_ADDRESS}-address-line-two`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.addressLine2 ?? '-',
            [`${EXHIBITION_ADDRESS}-address-line-three`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.addressLine3 ?? '-',
            [`${EXHIBITION_ADDRESS}-postal-code`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.postalCode ?? '-',
            [`${EXHIBITION_ADDRESS}-building-name`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.buildingName ?? '-',
            [`${EXHIBITION_ADDRESS}-block-house-no`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.blockNo ?? '-',
            [`${EXHIBITION_ADDRESS}-street-name`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.streetName ?? '-',
            [`${EXHIBITION_ADDRESS}-floor-level-optional`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.floor ?? '-',
            [`${EXHIBITION_ADDRESS}-unit-optional`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.unit ?? '-',


            [`${TYPE_OF_EXHIBITION}-exhibition-type`]: licenceDetails?.ExhibitionDetails?.TypeOfExhibition ?? '-',

            [`${TYPE_OF_EQUIPMENT}-equipment-type`]: licenceDetails?.ExhibitionDetails?.mediaType ?? '-',      

            [`${STATION}-station-name`]: stationList ?? '-',
            [`${STATION}-total-number-of-stations`]: licenceDetails.baseLandFixedStationInfo ? String(licenceDetails.baseLandFixedStationInfo.length) : '-',


            [`${BASE_STATION_INFORMATION}-list`]: baseLandFixedStationInfoList ?? [...baseLandFixedStationInfoList],

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    if (transactionType === 'Cancel') {
        licence = {
            id: 'cancel-licence-details',
            formID: 'cancel-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.cancellationInformation?.licenceNumber ?? '',

                [`${LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '',
                [`${LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? '',

                [`${CANCEL_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    if (transactionType === 'Renew') {
        licence = {
            id: 'renew-licence-details',
            formID: 'renew-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${RENEW_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${RENEW_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${RENEW_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${RENEW_LICENCE_DETAILS}-invoiceNo`]: licenceDetails?.licenceRenewal?.invoiceNumber ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalAmount`]: licenceDetails?.licenceRenewal?.renewalAmount ?? '',
                [`${RENEW_LICENCE_DETAILS}-giroIndicator`]: licenceDetails?.licenceRenewal?.giroIndicator ?? '',
                [`${RENEW_LICENCE_DETAILS}-dateOfExpiry`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.dateOfExpiry) ?? '',
                [`${RENEW_LICENCE_DETAILS}-paymentDueDate`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.paymentDueDate) ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalPeriod`]: licenceDetails?.licenceRenewal?.renewalPeriod ?? ''
            }
        };
    }

    if (transactionType === 'Amend') {
            const mapped = (
                licenceDetails?.iwantToAmend ||
                licenceDetails?.licenceDetails?.iwantToAmend ||
                licenceDetails?.iWantToUpdate ||
                licenceDetails?.licenceDetails?.iWantToUpdate
            )?.map((data: { [key: string]: string }) => {
                return {
                    type: data.mixedValue
                };
            });
    
            licence = {
                id: 'amend-exhibition-of-telecommunication-equipment-without-frequency',
                formID: 'amend-exhibition-of-telecommunication-equipment-without-frequency',
                hasError: true,
                title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
                values: {
                    [`${LICENCE_CATEGORY}-amend-table`]: Array.isArray(mapped) && mapped.length > 0 ? [...mapped] : [],
                    [`${LICENCE_CATEGORY}-licence-category`]: licenceDetails?.LicenceCategoryDetails?.pleaseSelectTheLicenceYouWishToApply ?? '-',
                    [`${LICENCE_VALIDITY_PERIOD}-validate-period`]: licenceDetails?.ValidityInDays ?? '-',


                    [`${OTHER_DETAILS}-proposed-used-of-system`]: licenceDetails?.otherDetails?.proposedUseOfSystemEquipment ?? '-',
                    [`${OTHER_DETAILS}-remarks`]: licenceDetails?.otherDetails?.remarks ?? '-',

                    [`${FOREIGN_COMPANY_DETAILS}-foreign-company-name`]: licenceDetails?.organisationInformation?.companyName ?? '-',
                    [`${FOREIGN_COMPANY_DETAILS}-address-line-one`]: licenceDetails?.organisationInformation?.registeredAddress?.foreignAddressLine1 ?? '-',
                    [`${FOREIGN_COMPANY_DETAILS}-address-line-two`]: licenceDetails?.organisationInformation?.registeredAddress?.foreignAddressLine2 ?? '-',
                    [`${FOREIGN_COMPANY_DETAILS}-address-line-three`]: licenceDetails?.organisationInformation?.registeredAddress?.foreignAddressLine3 ?? '-',
                    [`${FOREIGN_COMPANY_DETAILS}-address-line-four`]: licenceDetails?.organisationInformation?.registeredAddress?.foreignAddressLine4 ?? '-',
                    [`${FOREIGN_COMPANY_DETAILS}-address-line-five`]: licenceDetails?.organisationInformation?.registeredAddress?.foreignAddressLine5 ?? '-',
                    [`${FOREIGN_COMPANY_DETAILS}-contact-number`]: licenceDetails?.organisationInformation?.telNumber ?? '-',
                    [`${FOREIGN_COMPANY_DETAILS}-email`]: licenceDetails?.organisationInformation?.email ?? '-',
                    [`${FOREIGN_COMPANY_DETAILS}-city`]: licenceDetails?.organisationInformation?.address?.city ?? '-',
                    [`${FOREIGN_COMPANY_DETAILS}-state`]: licenceDetails?.organisationInformation?.address?.state ?? '-',
                    [`${FOREIGN_COMPANY_DETAILS}-zip-code`]: licenceDetails?.organisationInformation?.address?.zipCode ?? '-',
                    [`${FOREIGN_COMPANY_DETAILS}-country`]: licenceDetails?.organisationInformation?.address?.country ?? '-',

                    [`${OPERATING_LOCATION}-list`]: operatingLocation ?? [...operatingLocation],

                    [`${EXHIBITION_INFORMATION}-organizer-name`]: licenceDetails?.ExhibitionDetails?.CompanyName ?? '-',
                    [`${EXHIBITION_INFORMATION}-organizer-contact-person`]: licenceDetails?.ExhibitionDetails?.contactPersonParticulars?.name ?? '-',
                    [`${EXHIBITION_INFORMATION}-designation`]: licenceDetails?.ExhibitionDetails?.contactPersonParticulars?.designation ?? '-',
                    [`${EXHIBITION_INFORMATION}-tel-no`]: licenceDetails?.ExhibitionDetails?.contactPersonParticulars?.officeTelNumber ?? '-',
                    [`${EXHIBITION_INFORMATION}-mobile-no`]: licenceDetails?.ExhibitionDetails?.contactPersonParticulars?.mobileNumber ?? '-',
                    [`${EXHIBITION_INFORMATION}-fax-no`]: licenceDetails?.ExhibitionDetails?.contactPersonParticulars?.faxNumber ?? '-',
                    [`${EXHIBITION_INFORMATION}-email`]: licenceDetails?.ExhibitionDetails?.contactPersonParticulars?.email ?? '-',
                    [`${EXHIBITION_INFORMATION}-exhibition-name`]: licenceDetails?.ExhibitionDetails?.contactPersonParticulars?.name ?? '-',
                    [`${EXHIBITION_INFORMATION}-exhibition-booth-no`]: licenceDetails?.ExhibitionDetails?.BoothNo ?? '-',

                    [`${EXHIBITION_PERIOD}-start-date`]: formatDateTo_ddMMyyyy(licenceDetails?.ExhibitionDetails?.StartDate) ?? '-',
                    [`${EXHIBITION_PERIOD}-end-date`]: formatDateTo_ddMMyyyy(licenceDetails?.ExhibitionDetails?.EndDate) ?? '-',

                    [`${EXHIBITION_ADDRESS}-address-type`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.addressType ?? '-',
                    [`${EXHIBITION_ADDRESS}-address-line-one`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.addressLine1 ?? '-',
                    [`${EXHIBITION_ADDRESS}-address-line-two`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.addressLine2 ?? '-',
                    [`${EXHIBITION_ADDRESS}-address-line-three`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.addressLine3 ?? '-',
                    [`${EXHIBITION_ADDRESS}-postal-code`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.postalCode ?? '-',
                    [`${EXHIBITION_ADDRESS}-building-name`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.buildingName ?? '-',
                    [`${EXHIBITION_ADDRESS}-block-house-no`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.blockNo ?? '-',
                    [`${EXHIBITION_ADDRESS}-street-name`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.streetName ?? '-',
                    [`${EXHIBITION_ADDRESS}-floor-level-optional`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.floor ?? '-',
                    [`${EXHIBITION_ADDRESS}-unit-optional`]: licenceDetails?.ExhibitionDetails?.registeredAddress?.unit ?? '-',


                    [`${TYPE_OF_EXHIBITION}-exhibition-type`]: licenceDetails?.ExhibitionDetails?.TypeOfExhibition ?? '-',

                    [`${TYPE_OF_EQUIPMENT}-equipment-type`]: licenceDetails?.ExhibitionDetails?.mediaType ?? '-',      

                    [`${STATION}-station-name`]: stationList ?? '-',
                    [`${STATION}-total-number-of-stations`]: licenceDetails.baseLandFixedStationInfo ? String(licenceDetails.baseLandFixedStationInfo.length) : '-',

                    [`${BASE_STATION_INFORMATION}-list`]: baseLandFixedStationInfoList ?? [...baseLandFixedStationInfoList],

                    [`${AMEND_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
                }
            };
        }

    return licence;
};

const exbApplicationPayload = {
    formatEXBApplication
};

export default exbApplicationPayload;

